<template>
  <div class="container mb-4" v-show="binList && binList.length != 0">
    <div v-show="binList && binList.length != 0">
      <p v-if="binCollectionHeader" v-html="binCollectionHeader"></p>
      <div class="table-responsive">
        <table class="table border table-entitlement">
          <thead class="thead-light">
            <tr>
              <th
                scope="col"
                class="p-1 pl-4 font-weight-bold paragraph-reduced"
                width="30%"
                v-html="tableHeaders.firstCol"
              ></th>
              <th
                scope="col"
                class="p-1 pl-4 font-weight-bold paragraph-reduced"
                v-html="tableHeaders.secondCol"
              ></th>
              <th
                scope="col"
                class="p-1 pl-4 font-weight-bold paragraph-reduced"
                v-html="tableHeaders.thirdCol"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(binData, i) in binList" :key="i">
              <td class="p-1 pl-4">{{ binData.displayName }}</td>
              <td class="p-1 pl-4">{{ Array.isArray(binData.items) && binData.items.length > 0 ? binData.items[0].binSize + "L" : "" }}</td>
              <td class="p-1 pl-4">{{ Array.isArray(binData.items) && binData.items.length > 0 ? binData.items[0].binQuantity : "" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import BinCollectionScheduleDownload from "../../../../common/components/BinCollectionScheduleDownload";
import BinCollectionScheduleItem from "../../../../common/components/BinCollectionScheduleItem";
import Helper from "../../../../helper";
import DateNoTz from "../../../../common/utils/DateNoTz";
import Texts from "../../../../common/utils/Texts";

export default {
  data() {
    return {
      binTypes: [],
      freqTypes: [],
      calenSettings: [],
      nextCollectionDates: [],
    };
  },
  components: {
    BinCollectionScheduleDownload,
    BinCollectionScheduleItem,
  },
  mounted() {
    this.loadScheduleTypes();
  },
  methods: {
    loadScheduleTypes() {
      this.$store
        .dispatch("getBinScheduleSetting", [
          "bin-type",
          "frequency-type",
          "calendar-setting",
        ])
        .then((dataList) => {
          this.binTypes = dataList[0] && dataList[0].list;
          this.freqTypes = dataList[1] && dataList[1].list;
          this.calenSettings = dataList[2] && dataList[2].list;
          this.loadAddressCollectionWeek();
        });
    },
    loadAddressCollectionWeek() {
      this.$store
        .dispatch("getAddressCollectionWeek", this.activeAddressId)
        .then((data) => {
          this.nextCollectionDates = (data && data.nextCollectionDates)
            .filter((item) => {
              return parseInt(item.binSize) > 0;
            })
            .map((item) => {
              item.binSize = item.binSize.trim();
              item.wasteStreamBinSize = `${item.binSize}:${item.wasteStream}`;
              return item;
            });
        });
    },
    getBin(wasteStream) {
      return this.binTypes.find((bin) => bin.api_value === wasteStream);
    },
    getFreq(collectionFrequency) {
      return this.freqTypes.find(
        (freq) => freq.api_value === collectionFrequency
      );
    },
    getDisplayName(wasteStream) {
      const bin = this.getBin(wasteStream);
      return (bin && bin.name) || wasteStream;
    },
    getDisplayNote(wasteStream) {
      const bin = this.getBin(wasteStream);
      return (bin && bin.notes) || "";
    },
    getDisplayFreq(waste) {
      const freq = this.getFreq(waste.collectionFrequency);
      return (freq && freq.name) || waste.collectionFrequency;
    },
    getDisplayIcon(wasteStream) {
      const bin = this.getBin(wasteStream);
      return (bin && bin.icon) || "";
    },
  },
  computed: {
		activeAddressId() {
      return this.$store.getters.GET_BOOKING_STATE.activeAddress ? this.$store.getters.GET_BOOKING_STATE.activeAddress.id : null;
    },
    tableHeaders() {
      return {
        firstCol: Texts.render(`BIN_COLLECTION_FIRST_COL`),
        secondCol: Texts.render(`BIN_COLLECTION_SECOND_COL`),
        thirdCol: Texts.render(`BIN_COLLECTION_THIRD_COL`),
      };
    },
    binCollectionHeader(){
      /*
        Stry: [HC] 1coast - text above bin size table
        Date: 2021-02-23
        Auth: Franco Mapua
        Desc: Hardcoding the bin collection schedule header
      */
      if(Helper.getPortalName() != "1coast"){
        return
      }
      const binCollectionHeaderMap = {
        "request a replacement bin" : "The bins listed below are allocated to your property. Please ensure you select the correct sized bin for repair/replacement.<br/><b>Please contact us on 1300 126 278 if you wish to upgrade or downgrade the size of your bin or to report a missing or stolen bin.</b>",
        "request repairs to your bin" : "The bins listed below are allocated to your property. Please ensure you select the correct sized bin for repair/replacement.<br/><b>Please contact us on 1300 126 278 if you wish to upgrade or downgrade the size of your bin or to report a missing or stolen bin.</b>",
      }
      var selectedServiceGroup = this.$store.getters.GET_BOOKING_STATE.selectedServiceGroup;
      var selectedServiceGroupName = selectedServiceGroup && typeof selectedServiceGroup.group_name == "string" ? selectedServiceGroup.group_name.toLowerCase() : null

      var foundHeader
      for (const name in binCollectionHeaderMap) {
        if (Object.hasOwnProperty.call(binCollectionHeaderMap, name) && name.toLowerCase() == selectedServiceGroupName) {
          foundHeader = binCollectionHeaderMap[name];
        }
      } 
      return foundHeader
    },
    binList() {
      const wastes = Helper.objectsGroupBy(
        this.nextCollectionDates,
        "wasteStreamBinSize"
      );
      for (let wasteStreamBinSize in wastes) {
        if (wastes.hasOwnProperty(wasteStreamBinSize)) {
          const wasteCollection = wastes[wasteStreamBinSize];
          const [binSize, wasteStream] = wasteStreamBinSize.split(":");
          wastes[wasteStreamBinSize] = {
            displayName: this.getDisplayName(wasteStream),
            displayNote: this.getDisplayNote(wasteStream),
            displayIcon: this.getDisplayIcon(wasteStream),
            displayFrequency: this.getDisplayFreq(wasteCollection[0]),
            items: wasteCollection,
          };
        }
      }

      return wastes;
    },
  },
};
</script>